export default __webpack_public_path__ + "static/media/personal_trainer.468fdb3e.svg";